import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { State } from './state';
import {map, Observable, of} from 'rxjs';
import { Appointment } from '../model/calendar';
import {FamilyEvaluationAppointment} from '../model/familyAndTeam';



@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

    loadCount : number = 0;


    constructor(private http: HttpClient) {
    }
// https://api-qa.huddy.io/api/schedulable-items?teamId=-1&size=10&search=&sortDir=desc&sortField=is_late_flag
    getSchedulableItems(teamId : number, size : number, offset : number,search : string, sortDir : string, sortField : string) {
      console.log('entering get schedulable items');
      const headers =  State.getAuthHeaders();
      const params = new HttpParams()
            .append('teamId', '-1')
            .append('offset', offset || 0)
            .append('size', size || 10)
            .append('search', search || '')
            .append('sortDir', sortDir || 'desc')
            .append('sortBy', sortField || 'is_late_flag');
      return this.http.get(State.config.host+ '/api/schedulable-items', { headers: headers, params: params })
        .pipe(map((response: any) => response,
          (error: any) => {
            throw error;
          }));
    }


    getCalendarItems() {
      console.log('entering get calendar items');
      const headers =  State.getAuthHeaders();
      if (State.user) {
        const params = new HttpParams()
              .append('email', ''+State.user?.trustedUser)
          .append('appointmentsOnly', '1');
        return this.http.get(State.config.host+ '/api/calendar-items', { headers: headers, params: params })
          .pipe(map((response: any) => response,
            (error: any) => {
              throw error;
            }));
        }
        return of(undefined);
    }

    getFamilyAppointments(familyId : number) {
      console.log('entering getFamilyAppointments');
      const headers =  State.getAuthHeaders();
      if (State.user) {
        const params = new HttpParams()
              .append('familyId', ''+familyId);
        return this.http.get(State.config.host+ '/api/appointments', { headers: headers, params: params })
          .pipe(map((response: any) => response,
            (error: any) => {
              throw error;
            }));
        }
        return of(undefined);
    }

    getAppointmentById(id : number) {
      console.log('entering getAppointmentById');
      const headers =  State.getAuthHeaders();

      return this.http.get(State.config.host+ '/api/appointment/' + id , { headers: headers })
        .pipe(map((response: any) => response,
          (error: any) => {
            throw error;
          }));

    }

    getNextEvaluationsForFamilies() : Observable<FamilyEvaluationAppointment[]> {
      console.log('entering getNextEvaluationsForFamilies');
      const headers =  State.getAuthHeaders();
      const params = new HttpParams()
        .append('providerId', ''+State.config.providerId);
      return this.http.get(State.config.host+ '/api/family-evaluation-appointments'  ,
        { headers: headers , params: params })
        .pipe(map((response: any) => response,
          (error: any) => {
            throw error;
          }));
    }

    saveAppointment(appointment :Appointment ) {

      return this.http.post(State.config.host + '/api/appointment', appointment, {headers: State.getAuthHeaders().append('allowDupes', 'true')})
      .pipe(map((r: any) => r,( error : any) => {
        throw error;
      }));
    }

     reset() {
      this.loadCount = 0;
      State.isLoaded = false;
      this.getCalendarItems().subscribe(response => {
        State.setState({
          discriminator: 'calendarEvents',
          calendarEvents: response
        });
        this.incrementLoadCount();
        this.getSchedulableItems(-1, 10, 0, '', 'desc', 'is_late_flag').subscribe(response => {
          State.setState({
            discriminator: 'schedulableItems',
            schedulableItems: response
          });
          this.incrementLoadCount();
          this.getNextEvaluationsForFamilies().subscribe(response => {
            State.setState({
              discriminator: 'familyEvaluationAppointments',
              familyEvaluationAppointments: response
            });
            this.incrementLoadCount();
          })
        });
      });



      if (State.currentFamily && State.currentFamily.id) {
        this.getFamilyAppointments(State.currentFamily.id).subscribe(response => {
          State.setState({
            discriminator: 'familyAppointments',
            familyAppointments: response
          });
        });
      }
       if (State.currentFamily && State.currentFamily.id) {
         this.getFamilyAppointments(State.currentFamily.id).subscribe(response => {
           State.setState({
             discriminator: 'familyAppointments',
             familyAppointments: response
           });
         });
       }
    }

    incrementLoadCount() {
      this.loadCount++;
      if (this.loadCount >= 3) {
        State.isLoaded = true;
      }
    }
}
